import styled from 'styled-components';
// Important: The only way I found this to be reliable if the pivot has to be at the bottom is to use bottom:0 and transform-origin: left bottom on the sprite-wrapper and then put the origin of the coordinate system on the bottom left.
// This means that if I want to change the pivot I will have to make changes here and on the useGameStageContext hook.

export const StyledSprite = styled.div.attrs(
  ({ responsiveTransform, currentFrame }) => {
    return {
      style: {
        '--width': `${responsiveTransform.width}px`,
        '--height': `${responsiveTransform.height}px`,
        '--x': `${responsiveTransform.x}px`,
        '--y': `${responsiveTransform.y}px`,
        '--frameX': `${-currentFrame.x}px`,
        '--frameY': `${-currentFrame.y}px`,
        '--frameWidth': `${currentFrame.width}px`,
        '--frameHeight': `${currentFrame.height}px`,
        '--scaleX': responsiveTransform.scaleX,
        '--scaleY': responsiveTransform.scaleY,
      },
    };
  }
)`
  width: var(--width);
  height: var(--height);
  position: absolute;
  transform: translate(var(--x), var(--y));
  transition: transform 100ms;
  .sprite-wrapper {
    position: absolute;
    transform-origin: left top;
    transform: scale(var(--scaleX), var(--scaleY));
    width: var(--frameWidth);
    height: var(--frameHeight);
    overflow: hidden;
    /* fix safari overflow hidden problem */
    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
    transition: transform 100ms;

    .sprite {
      position: absolute;
      display: block;
      transform: translate(var(--frameX), var(--frameY));
    }

    .grid {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .grid-box {
        width: 50%;
        height: 50%;
        border: 1px dashed coral;
      }
    }

    .reference {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
`;
